import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";

import { AuthContent } from "../components/signin/authContent";

import { isSessionAuthenticated } from "../services/auth";

export const Signin = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const initialize = async () => {
      const isLoggedIn = await isSessionAuthenticated();

      if (isLoggedIn) {
        navigate("/");
        return;
      }

      setIsLoading(false);
    };

    initialize();
  }, []);

  if (isLoading) {
    return <CircularProgress size={16} />;
  }

  return (
    <>
      {/* <Box
        component="header"
        width="100%"
        position="fixed"
        top={0}
        padding={10}
        display={{ xs: "none", sm: "block" }}
      >
        <img src={FullLogo} alt="full logo" loading="lazy" />
      </Box> */}
      <Stack
        width="100%"
        minHeight="100dvh"
        direction="column"
        alignItems="center"
        justifyContent={{ xs: "flex-start", sm: "center" }}
        gap={{
          xs: 6,
          sm: 12,
        }}
        padding={{
          xs: 6,
          sm: 0,
        }}
        paddingTop={{
          xs: 6,
          sm: 16,
        }}
        paddingBottom={{
          xs: 0,
          sm: 16,
        }}
      >
        <AuthContent />
      </Stack>
    </>
  );
};
